import { SEND_TRANSACTIONS_PAYMENT } from './../constants';
import { handleActions } from "redux-actions"

export const transactions  = handleActions(
  {
    [ SEND_TRANSACTIONS_PAYMENT ]: (state, action) => action.payload
  }, {}
)